import { getClient } from "~/src/services/graphql";
import { GRAPHQL_ADMIN_ENDPOINT } from "~/src/config";

export default getClient(GRAPHQL_ADMIN_ENDPOINT);
